import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";

class EventshistoryController {
  constructor($http, $localStorage, $state, AuthService, EventsService, $location, $timeout) {
    this.name = "eventshistory";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.activeTab = "complete";
    this.$location = $location;
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 1;
    this.currentPageNumber = 1;
    this.events = [];
    this.query = "";
    this.navOptions = [
      {
        type: "complete",
        isActive: "profile-menu-active",
        value: "Completed jobs",
      },
      {type: "cancelled", isActive: "", value: "Cancelled jobs"},
    ];

    var _this = this;

    console.log("what is this");
    console.dir(_this.$state);
    console.log("what is the current user");
    console.dir(_this.currentUser);

    this.remain_loading_count--;

    this.$events.get_history("isCompleted", this.$localStorage.logged_user.companyId, 0, 10, "isCompleted", "lastUpdated", "desc").then(
      function (data) {
        _this.events = data.data;
        _this.remain_loading_count = 0;
        _this.calculatePagination();
      },
      function (data) {
        _this.events = [];
        _this.remain_loading_count++;
        if (data.status === 401) {
          _this.$state.go("signin");
        } else {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      }
    );

    $("jobbleheader .main-menu ul li:nth-child(3)").removeClass().addClass("active");

    if (_this.$location.$$hash === "modal-complete-last-event-confirm-modal") {
      jQuery(".modal-backdrop").remove();
      jQuery("body").removeClass("modal-open");
    }
  }

  navigateProfilePage(type) {
    var _this = this;

    _this.remain_loading_count++;
    this.navOptions.forEach(function (option) {
      if (option.type === type) {
        option.isActive = "profile-menu-active";
      } else {
        option.isActive = "";
      }
    });

    if (type === "complete") {
      console.log("in complete");
      this.activeTab = "complete";
      this.$events.get_history("isCompleted", this.$localStorage.logged_user.companyId, 0, 20, "isCompleted", "lastUpdated", "desc").then(
        function (data) {
          _this.events = data.data;
          _this.remain_loading_count--;
        },
        function (data) {
          _this.events = [];
        }
      );
    }

    if (type === "cancelled") {
      this.activeTab = "cancelled";
      this.$events.get_history("isCancelled", this.$localStorage.logged_user.companyId, 0, 20, "isCompleted", "lastUpdated", "desc").then(
        function (data) {
          _this.events = data.data;
          _this.remain_loading_count--;
        },
        function (data) {
          console.log(data);
          _this.events = [];
        }
      );
    }
  }

  getEventDate(raw_date) {
    var date = new Date(raw_date);
    return moment(date).format("MMM DD, YYYY");
  }

  clickMagnify() {
    jQuery(".search-container").addClass("s-open");
    jQuery(".search-container").find('input[type="search"]').focus();
  }

  closeSearch() {
    jQuery(".search-container").removeClass("s-open");
    this.query = "";
  }

  calculatePagination() {
    this.pages = [];
    console.log("calc page");
    console.dir(this.$localStorage);

    if (!this.$localStorage.logged_user.company) {
      this.pages.push(1);
    } else {
      var numberOfEvents = Math.ceil(this.$localStorage.logged_user.company.totalNumberOfCloseEvents / 10);
      for (var i = 0; i < numberOfEvents; i++) {
        this.pages.push(i + 1);
      }
    }
  }

  paginate(pageNumber) {
    console.log("go to this page");

    if (pageNumber < 1 || pageNumber > this.pages.length) {
      return;
    }

    this.currentPageNumber = pageNumber;
    this.remain_loading_count = 1;
    this.events = [];

    var companyId = this.$localStorage.logged_user.companyId;
    var offsetParam = pageNumber * 10 - 10,
      maxParam = 10,
      page = "live",
      sort = "lastUpdated",
      order = "desc";

    var _this = this;

    this.$events.get_history("isCompleted", companyId, offsetParam, maxParam, page, sort, order).then(
      function (data) {
        _this.events = data.data;
        console.log(_this.events);
        _this.remain_loading_count--;
      },
      function (data) {
        console.log(data);
        _this.events = [];
        _this.remain_loading_count--;
      }
    );
  }
}

EventshistoryController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "$location", "$timeout"];

export default EventshistoryController;



// WEBPACK FOOTER //
// ./client/app/components/eventshistory/eventshistory.controller.js